module.exports = __webpack_public_path__ + "img/header-sr.e00310e7.jpg";